import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {UserService} from '@uofu-uss-aux/software-catalog-ng-core';

@Component({
  selector: 'app-username',
  templateUrl: './username.component.html',
  styleUrls: ['./username.component.scss'],
  standalone: true,
})
export class UsernameComponent implements OnInit, OnDestroy {

  username = '';
  private subscription: Subscription;

  constructor(private readonly userService: UserService) {
  }

  ngOnInit(): void {
    const observer = {
      next: (user) => {
        this.username = user ? user.name : '';
      },
      error: () => {
        this.username = '';
      },
    };
    this.subscription = this.userService.observable.subscribe(observer);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

